module.exports = __webpack_public_path__ + "static/media/nect-logo-color.701ae3ce.svg";